/**
 * @created with WebStorm.
 * @name: encrypt
 * @author: liangYan
 * @date: 2022-12-09 16:27 星期五
 * @description：加密解密文件
 */
import CryptoJS from "crypto-js";

//const keyStr = 'd456ff2af67d0a534db221808425a9f5';
const keyStr = CryptoJS.enc.Utf8.parse('d456ff2af67d0a534db221808425a9f5');
const ivStr = CryptoJS.enc.Utf8.parse('');

export default {
	/***
	 * AES加密
	 * @param text
	 * @returns {*}
	 */
	encrypt(text) {
		var key = keyStr; //为了避免补位，直接用16位的秘钥
		var iv = ivStr; //16位初始向量
		if (typeof text === 'object') {
			text = JSON.stringify(text);
		}
		var encrypted = CryptoJS.AES.encrypt(text, key, {
			iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		return encrypted.toString();
	},
	/***
	 * AES解密
	 * @param text
	 * @returns {*}
	 */
	decrypt(text) {
		var key = keyStr; //为了避免补位，直接用16位的秘钥
		var iv = ivStr; //16位初始向量
		var encrypted = CryptoJS.AES.decrypt(text, key, {
			iv,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7
		});
		return encrypted.toString(CryptoJS.enc.Utf8);
	},
	/***
	 * 生成随机字符串
	 * @param len
	 * @returns {string}
	 */
	random(len) {
		let timestamp = (new Date()).valueOf(); //当前时间戳
		len = (len || 32) - timestamp.toString().length;
		let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
		let maxPos = chars.length;
		let str = '';
		for (let i = 0; i < len; i++) {
			str += chars.charAt(Math.floor(Math.random() * maxPos));
		}
		return str + timestamp;
	}
};


// WEBPACK FOOTER //
// ./src/utils/encrypt.js